import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Guides/guides.css"; 
import "./getStarted.css"; 
import { MainContent, ImageInline, ProgressBar } from "./GetStartedHelpers.jsx";
import Tooltip from "../Guides/Tooltip.jsx";
import Seo from "../Seo.jsx";
import getStartedConfig from "../../config/getStartedConfig.js";
import betfred from "./betfred.png";
import mb1 from "./mb1.png";
import mb2 from "./mb2.png";

const GetStarted2 = () => {
  const meta = getStartedConfig.getStarted2?.seo || {};
  const progress = getStartedConfig.progress || { currentStep: 1, totalSteps: 4 };

  const navigate = useNavigate();

  // This handler will be passed to the ProgressBar.
  const handleStepClick = (stepIndex) => {
    const targetRoute = `/get-started/step${stepIndex + 1}`;
    if (targetRoute) {
      navigate(targetRoute);
    }
  };

  return (
    <MainContent>
      <Seo title={meta.title} description={meta.description} url={getStartedConfig.getStarted2?.route || "/get-started/step2"}/>

      <ProgressBar currentStep={progress.currentStep} totalSteps={progress.totalSteps} onStepClick={handleStepClick} />

      <h1>Understand Matched Betting in 180 Seconds</h1>

      <section>
        <ImageInline
          imageSrc={betfred}
          alt="Diagram of Matched Betting Basics"
          annotations={
            <div>
              <h2>Step 1: Place a qualifying bet</h2>
              <p>We need to bet £10. We do this <em>without risking our money</em>.</p>
            </div>
          }
        />
      </section>

      <section>
      <h3>How to do this?</h3>
      <div className="grid-fixed g2">
        <div className="col">
        <img src={mb1} alt="How does matched betting work?" />
        <h3>1. Place a bet</h3>
        <p>
        For example, place a £10 <span className="back">back</span> bet that Arsenal <em>will</em> win the match with <span className="key">Betfred</span>.
      </p>
        <h6 className="info mb-0">A <span className="back">back</span> bet is a bet that an outcome <em>will</em> happen.</h6>
        </div>
        <div className="col">
        <img src={mb2} alt="How does matched betting work?" />
        <h3>2. Cancel out that bet</h3>
        <p>
        For example, place a <span className="lay">lay</span> bet that Arsenal <em>will not</em> win the match with <Tooltip content="A platform where you bet against other people, rather than a bookie.">an exchange</Tooltip>.

        </p>
        <h6 className="info mb-0">A <span className="lay">lay</span> bet is a bet that an outcome <em>will not</em> happen.</h6>
        </div>

      </div>
      <h6 className="info">You would now be awarded a £50 free bet. We need to lock in a profit without risking the bonus...</h6>
      </section>
      <Link to="/get-started/step3">
        <button className="next-button">Next</button>
      </Link>    
    </MainContent>
  );
};

export default GetStarted2;
